export const switchCompany = {
  invalidOtpMessage: 'Invalid OTP code provided',
  confirmOtpErrorMessage: 'Something went wrong. Could not confirm OTP for switching pharmacies',
  loginAgainSuffix: '. Please login again.',
  switchCompanyErrorMessage: 'Something went wrong. Could not switch pharmacy',
  getCompanyUserErrorMessage: 'Something went wrong. Could not get pharmacy user',
  loadingTitle: 'Loading',
  loadingDescription: 'Switching pharmacies. Please wait...',
  twoFactorAuthTitle: 'Two-Factor Authentication',
  otpInstructions:
    "We've sent a one-time code to the device associated with your account. Please enter the code below to proceed with switching the Pharmacy.",
  otpFieldLabel: 'One-Time Code',
  submitButtonLabel: 'Switch Pharmacy',
  cancelLabel: 'Cancel',
  successTitle: 'Success',
  successDescription: (previousCompanyName: string, newCompanyName: string) =>
    `You have been signed out of ${previousCompanyName}. \n Please wait, you're now signing into ${newCompanyName}.`,
  errorTitle: 'Error',
  errorDescription: (newCompanyName: string) => `Something went wrong. Could not sign into ${newCompanyName}`
} as const;
